import { Flex, Link, useTheme } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";

export const ConfirmResetPasswordFooter = () => {
  const { tokens } = useTheme();
  const { t } = useTranslation();

  return (
    <Flex
      alignItems="center"
      direction="column"
      gap=".5rem"
      padding={tokens.space.small}
    >
      <Link
        onClick={() =>
          (window.location.href =
            "mailto:help@simpl.org?subject=Desktop Login Help")
        }
      >
        {t("Help & Support")}
      </Link>
    </Flex>
  );
};
